import React, { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react';
import cn from 'classnames';

import styles from './input.module.scss';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {

}

function Input(props: IInputProps, ref: ForwardedRef<HTMLInputElement>) {
  const { className, ...restProps } = props;

  return (
    <input
      {...restProps}
      ref={ref}
      className={cn(styles.input, className)}
    />
  );
}

export default forwardRef(Input);
